export function ConcatAddressLine(values, excludeBlanks = true) {
  if (excludeBlanks) {
    return values.filter(value => value && value !== '').join(', ');
  }

  return values.join(', ');
}

export function GetCommonWFormWellFormedAddress(formAddress) {
  const wellFormedAddress = {
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    postalCode: '',
    country: ''
  };

  const splitLine1 = formAddress?.street?.split(',')?.map(x => x.trim())?.reverse() ?? ['', ''];
  const splitLine2 = formAddress?.cityCountyStateProvince?.split(',')?.map(x => x.trim())?.reverse() ?? ['', '', ''];

  wellFormedAddress.country = formAddress?.country;
  if (splitLine1.length >= 2) {
    [wellFormedAddress.line2, ...wellFormedAddress.line1] = splitLine1;
  } else {
    [...wellFormedAddress.line1] = splitLine1;
  }

  if (splitLine2.length >= 3) {
    [wellFormedAddress.postalCode, wellFormedAddress.line4, ...wellFormedAddress.line3] = splitLine2;
  } else if (splitLine2.length === 2) {
    [wellFormedAddress.line4, ...wellFormedAddress.line3] = splitLine2;
  } else {
    [...wellFormedAddress.line3] = splitLine2;
  }

  wellFormedAddress.line1 = wellFormedAddress.line1.reverse().join(', ');
  wellFormedAddress.line3 = wellFormedAddress.line3.reverse().join(', ');

  return wellFormedAddress;
}

export function CheckValidPostalCodeAndLine3And4Combination(postalCode, line3, line4) {
  if (!postalCode) {
    return true;
  }

  if ((!line3 && !line4) || !line4) {
    return false;
  }

  return true;
}

export function GetCommonWFormFieldPathValueMap(addressPath, wellFormedAddress) {
  const validPostalCodeAndLine3And4Combination = CheckValidPostalCodeAndLine3And4Combination(wellFormedAddress?.addressPostalCode, wellFormedAddress?.addressLine3, wellFormedAddress?.addressLine4);

  const fieldPathValueDictionary = [
    { key: `${ addressPath }.street`, value: ConcatAddressLine([wellFormedAddress?.addressLine1, wellFormedAddress?.addressLine2]) },
    { key: `${ addressPath }.cityCountyStateProvince`, value: ConcatAddressLine([wellFormedAddress?.addressLine3, wellFormedAddress?.addressLine4, wellFormedAddress?.addressPostalCode], validPostalCodeAndLine3And4Combination) },
    { key: `${ addressPath }.country`, value: wellFormedAddress?.addressCountry }
  ];

  return fieldPathValueDictionary;
}

export function GetCommonCrsFormWellFormedAddress(formAddress) {
  const wellFormedAddress = {
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    postalCode: '',
    country: ''
  };

  const splitLine1 = formAddress?.street?.split(',')?.map(x => x.trim())?.reverse() ?? ['', ''];
  const splitLine2 = formAddress?.cityCountyStateProvince?.split(',')?.map(x => x.trim())?.reverse() ?? ['', ''];

  if (splitLine1.length >= 2) {
    [wellFormedAddress.line2, ...wellFormedAddress.line1] = splitLine1;
  } else {
    [...wellFormedAddress.line1] = splitLine1;
  }

  if (splitLine2.length >= 2) {
    [wellFormedAddress.line4, ...wellFormedAddress.line3] = splitLine2;
  } else {
    [...wellFormedAddress.line3] = splitLine2;
  }

  wellFormedAddress.postalCode = formAddress?.postalCode;
  wellFormedAddress.country = formAddress?.country;

  wellFormedAddress.line1 = wellFormedAddress.line1.reverse().join(', ');
  wellFormedAddress.line3 = wellFormedAddress.line3.reverse().join(', ');

  return wellFormedAddress;
}

export function GetCommonCrsFormFieldPathValueMap(addressPath, wellFormedAddress) {
  const fieldPathValueDictionary = [
    { key: `${ addressPath }.street`, value: ConcatAddressLine([wellFormedAddress?.addressLine1, wellFormedAddress?.addressLine2]) },
    { key: `${ addressPath }.cityCountyStateProvince`, value: ConcatAddressLine([wellFormedAddress?.addressLine3, wellFormedAddress?.addressLine4]) },
    { key: `${ addressPath }.postalCode`, value: wellFormedAddress?.addressPostalCode },
    { key: `${ addressPath }.country`, value: wellFormedAddress?.addressCountry }
  ];

  return fieldPathValueDictionary;
}

export function GetCommonCombinedFormWellFormedAddress(formAddress) {
  const wellFormedAddress = {
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    postalCode: '',
    country: ''
  };

  const splitLine1 = formAddress?.line1?.split(',')?.map(x => x.trim())?.reverse() ?? ['', ''];

  if (splitLine1.length >= 2) {
    [wellFormedAddress.line2, ...wellFormedAddress.line1] = splitLine1;
  } else {
    [...wellFormedAddress.line1] = splitLine1;
  }

  // The mismatch between lines here is intentional and based on the structure of addresses on combined forms
  wellFormedAddress.line3 = formAddress?.line2;
  wellFormedAddress.line4 = formAddress?.line3;
  wellFormedAddress.postalCode = formAddress?.postalCode;
  wellFormedAddress.country = formAddress?.country;

  wellFormedAddress.line1 = wellFormedAddress.line1.reverse().join(', ');

  return wellFormedAddress;
}

export function GetCommonCombinedFormFieldPathValueMap(addressPath, wellFormedAddress) {
  const fieldPathValueDictionary = [
    { key: `${ addressPath }.line1`, value: ConcatAddressLine([wellFormedAddress?.addressLine1, wellFormedAddress?.addressLine2]) },
    { key: `${ addressPath }.line2`, value: wellFormedAddress?.addressLine3 },
    { key: `${ addressPath }.line3`, value: wellFormedAddress?.addressLine4 },
    { key: `${ addressPath }.postalCode`, value: wellFormedAddress?.addressPostalCode },
    { key: `${ addressPath }.country`, value: wellFormedAddress?.addressCountry }
  ];

  return fieldPathValueDictionary;
}
